module.exports = __webpack_public_path__ + "static/media/Tw_color.0782df6c.svg";